import React from 'react';
import { Link, withRouter } from 'react-router-dom'

const SideBarNavigationLink = ({ to, children, active }) => {
  return (
    <li className={(active ? 'active' : null)}>
      <Link to={to + location.search}>
        {children}
      </Link>
    </li>
  )
}

export default withRouter(SideBarNavigationLink);



// WEBPACK FOOTER //
// ./src/components/layout/SideBarNavigationLink.js